import { render, staticRenderFns } from "./StackedAreaChart.vue?vue&type=template&id=231cc156&scoped=true"
import script from "./StackedAreaChart.vue?vue&type=script&lang=js"
export * from "./StackedAreaChart.vue?vue&type=script&lang=js"
import style0 from "./StackedAreaChart.vue?vue&type=style&index=0&id=231cc156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231cc156",
  null
  
)

export default component.exports